import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const InvalidAccountError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">Seems like your savings account is not available.</Text>
      <Text className="error-description">Please visit your nearest Axis Bank branch for any queries and then re-initiate your transaction.</Text>
    </Fragment>
  )
}

export default InvalidAccountError;
